import Route from '@ember/routing/route';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { hash } from 'rsvp';
import { routeEvent } from 'garaje/utils/decorators/route';

export default class extends Route {
  @service transitionConfirm;
  @service store;

  queryParams = {
    showFieldOptions: {
      replace: true,
    },
  };

  async model() {
    const model = this.modelFor('location-overview.sign-in-flows.show');
    const signInFieldPageId = get(model, 'globalFlow.signInFieldPage.id');
    const includes = ['sign-in-field-actions', 'actionable-sign-in-field-actions', 'actionable-sign-in-fields'];
    const signInFieldPage = await this.store.findRecord('global-sign-in-field-page', signInFieldPageId, {
      reload: true,
      include: includes.map((include) => `sign-in-fields.${include}`).join(','),
    });
    const signInFieldActionRuleGroups = this.store.query('global-sign-in-field-action-rule-group', {
      filter: { flow: model.globalFlow.id },
      page: { limit: 200 },
      include: 'sign-in-field-actions,sign-in-field-actions-contacts,sign-in-field-actions-contacts.employee',
    });

    return hash({
      signInFields: get(signInFieldPage, 'signInFields'),
      signInFieldActionRuleGroups,
      globalFlow: model.globalFlow,
      locations: model.locations,
      visualComplianceConfiguration: get(model.globalFlow, 'visualComplianceConfiguration'),
    });
  }

  @routeEvent
  routeWillChange(transition) {
    const changeset = get(this.controller, 'changeset');
    const confirmTask = get(this, 'transitionConfirm.displayConfirmTask');

    if (changeset) {
      if (get(changeset, 'isDirty')) {
        confirmTask.perform(transition, {
          continue() {
            changeset.rollbackAttributes();
          },
        });
      }
    }
  }
}
